module.exports = __webpack_public_path__ + "img/norwich-logo-icon.fbf19031.png";